import account, { logout } from '@lib/auth/account'
import { addToast } from '@lib/components/Toast'
import { t } from '@/i18n'

// 後端對未知產品線的兩種回法：權限檢查路由 400、currencies 422
export function isUnknownProductLineError(r) {
  const msg = r?.data?.error
  return (r?.status === 400 && msg === 'unknown product line') || (r?.status === 422 && msg === 'Invalid product')
}

let lastUnknownProductToast = 0
function notifyUnknownProductLine(r) {
  console.error('[unknown product line]', r.url)
  const now = Date.now()
  if (now - lastUnknownProductToast < 3000) return
  lastUnknownProductToast = now
  addToast({ level: 'error', message: t('app', 'Unknown product line') })
}

// 將 fetch response 轉為含 data 的物件。永遠回傳物件，呼叫端可安全存取 r.status / r.data。
// 401 會觸發 logout + reload，並回傳 { status: 401, data: null }。
export async function res2json(r) {
  if (r.status === 401) {
    if (account().username) {
      logout()
      document.location.reload()
    }
    return { status: 401, data: null }
  }
  if (r.status !== 204) {
    try {
      r.data = await r.json()
    } catch {
      console.error(await r.text().catch(() => ''))
      r.data = null
    }
    if (isUnknownProductLineError(r)) notifyUnknownProductLine(r)
  }
  return r
}

// 後端 export_order.filepath 是相對路徑，靜態檔案由 /files/ prefix 提供
export function getDownloadUrl(filepath) {
  if (!filepath) return ''
  return `/files/${filepath}`
}
